import styled from "styled-components";

import Color, { alpha } from "../resources/colors";
import { FadeAnimation } from "../pandora/animations";

const Overlay = styled("div")<{css? : string}>`
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background: ${ alpha(Color.darkGrey, 0.7) };
    position: fixed;

    animation: ${FadeAnimation} 0.2s linear 1;

    ${props => props.css ?? ""}
`
export default Overlay;

